export let errorCannotCompleteRequestLineOne = "RkQZ5c";
export let errorCannotCompleteRequestLineTwo = "rAfX8c";
export let safeToCloseString = "j0o$kb";
export let nothingIsSelected = "UgwMAc";
export let errorMessageNotFound = "oaUjle";
export let goToInboxString = "sdte8";
export default {errorCannotCompleteRequestLineOne,errorCannotCompleteRequestLineTwo,safeToCloseString,nothingIsSelected,errorMessageNotFound,goToInboxString};